import type { StoreHit } from "@components/try-and-buy/types/store";
import type { ProductVariant } from "@graphql/generated/types";

export const hasAvailabilityInStore = ({
    variants,
    selectedSku,
    supplyChannels,
}: {
    variants: ProductVariant[];
    selectedSku: string;
    supplyChannels: string[];
}) => {
    const selectedVariant = variants.find(({ sku }) => sku === selectedSku);

    const availabilityChannels = selectedVariant?.availability.channels?.results
        .filter((result) => result.availability.isOnStock)
        .map((c) => c.channel)
        ?.filter((channel) => channel?.key !== process.env.NEXT_PUBLIC_STORE_KEY);

    return Boolean(availabilityChannels?.find((channel) => supplyChannels.includes(channel.id)));
};

export const getHoursText = ({
    hours,
    closedLabel,
}: {
    hours: StoreHit["operatingHours"][number]["hours"];
    closedLabel: string;
}) => {
    const formatTime = (time: string) => time.slice(0, 5);

    const getText = ({ opening, closed }: { opening: string; closed: string }) =>
        opening === closed ? closedLabel : `${formatTime(opening)} – ${formatTime(closed)}`;

    return hours.map(getText).join(", ");
};
